<template>
  <div class="per-container">
    <div class="flexbox-container">
      <div class="boxs">
        <div class="top">
          <img src="../../assets/img/logo.png" alt />
          <div class="t-r">
            <span class="zz">智蛛AI</span>
            <span style="yzz">有“智”者，事竟成</span>
          </div>
        </div>
        <div class="content">
          <div class="content1">
            <div class="t1">
              <p>比亚迪</p>
              <p>智蛛AI经销商运营平台</p>
            </div>
            <div class="c1-t">有“智”者，事竟成</div>
            <div class="downs">
              <div
                class="ios"
                @mousemove="mouseOver(1)"
                @mouseleave="mouseLeave(1)"
              >
                <img src="../../assets/img/IOS.png" alt />
                ios版
                <div class="iosImg" v-show="isHover1">
                  <img src="../../assets/img/aniImgIos.png" alt />
                </div>
              </div>
              <div
                class="ani"
                @mousemove="mouseOver(2)"
                @mouseleave="mouseLeave(2)"
              >
                <img src="../../assets/img/ani.png" alt />安卓版
                <div class="aniImg" v-show="isHover2">
                  <img src="../../assets/img/aniImg.png" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="content2">
            <div class="title">小智欢迎您</div>
            <div class="loading">
              <img src="../../assets/img/loading.gif" alt="" srcset="" />
              正在登陆
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">产品监制 | 比亚迪汽车产业办</div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import { goCas, dealerNetMap } from '@/assets/js/constant'
import { mapActions } from 'vuex'
import { deviceTypeMap } from "@/assets/js/commonMap.js";
import { getExplore } from '@/assets/js/util'
const explore = getExplore()
export default {
  name: "AuthRedirect",
  data() {
    return {
      isHover1: false,
      isHover2: false,
      form: {
        deviceType: '',
        deviceVersion: '', // 操作系统版本 window11
        device: `${explore.name} ${explore.fullVersion}`, // 浏览器类型
      },
    };
  },
  computed: {
    ...mapGetters('common', ['osInfo']),
  },
  methods: {
    mouseOver(v) {
      if (v == 1) {
        this.isHover1 = true;
      } else {
        this.isHover2 = true;
      }
    },
    mouseLeave(v) {
      if (v == 1) {
        this.isHover1 = false;
      } else {
        this.isHover2 = false;
      }
    }
  },
  async created() {
    await this.getModernOSInfo()
    const { name, versionName } = this.osInfo
    this.form.deviceVersion = versionName
    this.form.deviceType = name
    this.$httpAuth
      .post("/v2/appUserService/newLogin", {
        appType: 1,
        deviceId: "1",
        appVersion: "1.0",
        qwCode: this.$route.query.logincode,
        ...this.getParams()
      })
      .then((res) => {
        if (res.data.code === 201) {
          this.$message({
            message: res.data.detail,
            type: "error"
          });
          setTimeout(() => {
            this.$router.replace({
              path: "/login"
            });
          }, 3000);
          return;
        }
        
        // const { profile = {}, token = '', isAdmin = '' } = res.data || {};
        // this.$common.setDealer(profile);
        // Cookies.set("Dealer-User-Token", token);
        // this.$common.setAdmin(isAdmin);
        // this.$common.setLoginInfo(res.data);
        // this.getConfigInfo()
        const { profile = {}, token = '', refreshToken = '', isAdmin = '' } = res.data || {};
        // 获取门店code 判断是否灰度 灰度跳转cas登录
        this.$common.setDealer(profile);
        const { dealerCode = '', type } = profile
        if(dealerCode) {
          this.getDealerCodeGray({ dealerCode, dealerNet: dealerNetMap.get(type) })
            .then(grayres=> {
              if(grayres?.data?.status === 1 && grayres?.data?.data) {
                goCas()
              } else {
                Cookies.set("Dealer-User-Token", token);
                Cookies.set("Dealer-User-RefreshToken", refreshToken);
                this.$common.setAdmin(isAdmin);
                this.$common.setLoginInfo(res.data);
                this.getConfigInfo()
              }
            })
        }
      });
  },
  methods: {
    ...mapActions('common', ['getDealerCodeGray', 'getModernOSInfo']),
    getParams() {
      const { device, deviceVersion, deviceType, } = this.form
      let value = {
        device,
        deviceType: deviceTypeMap.get(deviceType), // deviceType：0 pc windows, 1 ANDROID 2: ios 3.小程序 4. 鸿蒙 5 pc mac
        deviceVersion,
      }
      return value
    },
    getConfigInfo() {
      this.$httpAuth
        .post("/v2/appBaseService/info", { token: process.env.VUE_APP_INFO_TOKEN })
        .then((response) => {
          this.$common.setBaseInfo(response.data);
          let href = `${location.origin}${location.pathname}#/dashboard/index`;
          location.href = href;
          // this.$router.replace({
          //   path: "/dashboard/index",
          // });
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.flexbox-container {
  width: 100%;
  color: #fff;
  background-image: url("../../assets/img/BG.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.boxs {
  width: 900px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

.top {
  width: 200px;
  height: 66px;
  margin-top: 31px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top img {
  width: 54px;
}

.t-r {
  width: 130px;
  height: 56px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.zz {
  font-size: 22px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 800;
  color: rgba(255, 255, 255, 1);
  line-height: 37px;
}

.yzz {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 16px;
}

.content {
  width: 100%;
  height: 499px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}

.content2 {
  width: 444px;
  height: 499px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 9px 16px 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  box-sizing: border-box;
  padding-left: 49px;
  padding-top: 50px;
  position: relative;
}

.content2 .title {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(50, 50, 50, 1);
  margin-bottom: 30px;
}

.content1 {
  width: 400px;
  height: 400px;
  padding-top: 50px;
  box-sizing: border-box;
}

.t1 {
  font-size: 33px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 800;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
  margin-bottom: 40px;
}

.c1-t {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.downs {
  width: 330px;
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
}

.downs > div {
  font-size: 18px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  width: 140px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.iosImg {
  position: absolute;
  width: 160px;
  height: 160px;
  border-radius: 10px;
  background-color: #fff;
  top: -170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.iosImg img {
  width: 160px;
}

.aniImg {
  position: absolute;
  width: 160px;
  width: 160px;
  border-radius: 10px;
  background-color: #fff;
  top: -170px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.aniImg > img {
  width: 160px;
}

.ios > img {
  width: 22px;
  margin-right: 7px;
}

.ani > img {
  width: 22px;
  margin-right: 7px;
}

.bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}

.loading {
  width: 354px;
  height: 390px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  color: rgba(50, 50, 50, 1);
}

.loading img {
  width: 70%;
}

.mb20 {
  margin-bottom: 25px !important;
}
</style>
